import {FlagIconByLocale} from '../../icons/flag-icons-by-locale'
import type {BioIconProps} from '../../icons/common-types'

export default function ExpertenReviewsLogo({locale, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold tablet:gap-1 tablet:text-base">
      <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <path d="M16.5539 15.1288L28.1675 8.48808L16.5539 1.84448L4.94016 8.48808L16.5539 15.1288Z" fill="white" />
        <path d="M15.7231 16.5547L4.10938 9.91401V23.2009L15.7231 29.8445V16.5547Z" fill="white" />
        <path opacity="0.5" d="M17.3848 16.5547V29.8445L28.9982 23.2009V9.91406L17.3848 16.5547Z" fill="white" />
      </svg>

      <span>Experten Reviews</span>
      <FlagIconByLocale
        locale={locale}
        className="absolute -right-7 -top-2 size-9 shrink-0 -rotate-12 tablet:-right-5 tablet:-top-1 tablet:size-6"
      />
    </div>
  )
}
